// ============================================
// BRAND COLOR PALETTES - ORGANIZED BY CATEGORY
// ============================================

// PRIMARY BRAND COLORS - Generated from #2563EB
export const defaultBrandColor = {
    50: '#EFF6FF',  // Very light
    100: '#DBEAFE', // Light
    200: '#BFDBFE', // Lighter
    300: '#93C5FD', // Light-medium
    400: '#60A5FA', // Medium-light
    500: '#3B82F6', // DEFAULT - Primary brand color
    600: '#2563EB', // Slightly darker
    700: '#1D4ED8', // Darker
    800: '#1E40AF', // Even darker
    900: '#1E3A8A', // Darkest
    DEFAULT: '#2563EB',
    light: '#DBEAFE',
    dark: '#1E3A8A',
};

// SECONDARY BRAND COLOR - Red #EF4444
export const defaultSecondaryColor = {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#991B1B',
    900: '#7F1D1D',
    DEFAULT: '#EF4444',
    light: '#FEE2E2',
    dark: '#B91C1C',
};

// SUCCESS COLOR
export const defaultSuccessColor = {
    50: '#F0F9F2',
    100: '#D9EDDE',
    200: '#B3DBBE',
    300: '#8DC99E',
    400: '#67B77E',
    500: '#087531',
    600: '#0A6A2B',
    700: '#085C24',
    800: '#064E1D',
    900: '#043A15',
    DEFAULT: '#087531',
    light: '#D9EDDE',
    dark: '#043A15',
};

// ERROR COLOR
export const defaultErrorColor = {
    50: '#FFEBEE',
    100: '#FFCDD2',
    200: '#EF9A9A',
    300: '#E57373',
    400: '#EF5350',
    500: '#EA1C2C',
    600: '#E53935',
    700: '#D32F2F',
    800: '#C62828',
    900: '#B71C1C',
    DEFAULT: '#EA1C2C',
    light: '#EF9A9A',
    dark: '#D32F2F',
};

// WARNING COLOR
export const defaultWarningColor = {
    50: '#FFF3E0',
    100: '#FFE0B2',
    200: '#FFCC80',
    300: '#FFB74D',
    400: '#FFA726',
    500: '#FF9800',
    600: '#FB8C00',
    700: '#F57C00',
    800: '#EF6C00',
    900: '#E65100',
    DEFAULT: '#FF9800',
    light: '#FFCC80',
    dark: '#F57C00',
};

// PENDING COLOR
export const defaultPendingColor = {
    50: '#FFFDE7',
    100: '#FFF9C4',
    200: '#FFF59D',
    300: '#FFF176',
    400: '#FFEE58',
    500: '#FBC02D',
    600: '#F9A825',
    700: '#F57F17',
    800: '#F9A825',
    900: '#F57F17',
    DEFAULT: '#FBC02D',
    light: '#FFF59D',
    dark: '#F57F17',
};

// INFO COLOR
export const defaultInfoColor = {
    50: '#E1F5FE',
    100: '#B3E5FC',
    200: '#81D4FA',
    300: '#4FC3F7',
    400: '#29B6F6',
    500: '#039BE5',
    600: '#0288D1',
    700: '#0277BD',
    800: '#01579B',
    900: '#014375',
    DEFAULT: '#039BE5',
    light: '#81D4FA',
    dark: '#0277BD',
};

// ======================
// BLUE FAMILY
// ======================



export const brandSky = {
    50: '#E5F7FD',
    100: '#BFE9FA',
    200: '#94DAF7',
    300: '#69CBF4',
    400: '#47BFF1',
    500: '#26B3EE',
    600: '#22A1D6',
    700: '#1D8BB7',
    800: '#187598',
    900: '#105167',
    DEFAULT: '#26B3EE',
};

export const brandCyan = {
    50: '#E5F8FC',
    100: '#BFECF7',
    200: '#94DFF2',
    300: '#69D2ED',
    400: '#47C8E9',
    500: '#26BFE5',
    600: '#22ACCE',
    700: '#1D94B1',
    800: '#187B94',
    900: '#105465',
    DEFAULT: '#26BFE5',
};

export const brandDeepOcean = {
    50: '#E5EDF6',
    100: '#BFD1E8',
    200: '#94B3D7',
    300: '#6995C6',
    400: '#477EBA',
    500: '#2668AE',
    600: '#225E9D',
    700: '#1D4F86',
    800: '#184170',
    900: '#102C4C',
    DEFAULT: '#2668AE',
};

// ======================
// PURPLE/VIOLET FAMILY
// ======================

export const brandPurple = {
    50: '#F2E5F9',
    100: '#DDBFF1',
    200: '#C694E8',
    300: '#AF69DF',
    400: '#9D47D8',
    500: '#8526D1',
    600: '#7722BC',
    700: '#651DA1',
    800: '#531886',
    900: '#39105B',
    DEFAULT: '#8526D1',
};

export const brandViolet = {
    50: '#F2E5FA',
    100: '#DDBFF2',
    200: '#C694EA',
    300: '#AF69E2',
    400: '#9D47DC',
    500: '#8B26D6',
    600: '#7D22C1',
    700: '#6B1DA6',
    800: '#59188B',
    900: '#3D105E',
    DEFAULT: '#8B26D6',
};

export const brandIndigo = {
    50: '#E7E9FD',
    100: '#C2C8FA',
    200: '#98A3F7',
    300: '#6E7EF4',
    400: '#4D62F1',
    500: '#2C46EE',
    600: '#283FD6',
    700: '#2236B7',
    800: '#1C2D98',
    900: '#131F67',
    DEFAULT: '#2C46EE',
};

export const brandFuchsia = {
    50: '#FCE5FA',
    100: '#F6BFF4',
    200: '#F094ED',
    300: '#EA69E6',
    400: '#E547E0',
    500: '#E026DB',
    600: '#CA22C5',
    700: '#AF1DA9',
    800: '#94188D',
    900: '#651061',
    DEFAULT: '#E026DB',
};

// ======================
// GREEN/TEAL FAMILY
// ======================

export const brandGreen = {
    50: '#F0F9F2',
    100: '#D9EDDE',
    200: '#B3DBBE',
    300: '#8DC99E',
    400: '#67B77E',
    500: '#087531',  // Primary brand green
    600: '#0A6A2B',
    700: '#085C24',
    800: '#064E1D',
    900: '#043A15',
    DEFAULT: '#087531',
};

export const brandEmerald = {
    50: '#E5FBF5',
    100: '#BFF4E4',
    200: '#94ECD2',
    300: '#69E4C0',
    400: '#47DEB2',
    500: '#26D8A4',
    600: '#22C394',
    700: '#1DA97F',
    800: '#188F6A',
    900: '#106248',
    DEFAULT: '#26D8A4',
};

export const brandTeal = {
    50: '#E5F7F4',
    100: '#BFE8E2',
    200: '#94D8CE',
    300: '#69C8BA',
    400: '#47BCAB',
    500: '#26AF9C',
    600: '#229E8D',
    700: '#1D887A',
    800: '#187267',
    900: '#104E46',
    DEFAULT: '#26AF9C',
};

export const brandMint = {
    50: '#E5FAF6',
    100: '#BFF2E8',
    200: '#94E9D9',
    300: '#69E0CA',
    400: '#47D9BE',
    500: '#26D2B2',
    600: '#22BDA0',
    700: '#1DA388',
    800: '#188A70',
    900: '#105E4D',
    DEFAULT: '#26D2B2',
};

export const brandLime = {
    50: '#F7FCE5',
    100: '#EAF6BF',
    200: '#DBF094',
    300: '#CCEA69',
    400: '#C0E547',
    500: '#B5E026',
    600: '#A3CA22',
    700: '#8DAF1D',
    800: '#779418',
    900: '#516510',
    DEFAULT: '#B5E026',
};

// ======================
// RED/ORANGE FAMILY
// ======================

export const brandRed = {
    50: '#FDE5E7',
    100: '#F9BFC4',
    200: '#F5949C',
    300: '#F16974',
    400: '#EE4755',
    500: '#EA1C2C',
    600: '#D31928',
    700: '#B81522',
    800: '#9C111C',
    900: '#6A0B13',
    DEFAULT: '#EA1C2C',
};

export const brandOrange = {
    50: '#FEF2E5',
    100: '#FDDABF',
    200: '#FCC094',
    300: '#FBA769',
    400: '#FA9347',
    500: '#F97F26',
    600: '#E07222',
    700: '#C2621D',
    800: '#A35218',
    900: '#703910',
    DEFAULT: '#F97F26',
};

export const brandAmber = {
    50: '#FFF8E5',
    100: '#FFECBF',
    200: '#FFDF94',
    300: '#FFD269',
    400: '#FFC847',
    500: '#FFBF26',
    600: '#E6AC22',
    700: '#C5951D',
    800: '#A57D18',
    900: '#705510',
    DEFAULT: '#FFBF26',
};

export const brandSunset = {
    50: '#FDEAE5',
    100: '#F9CBBF',
    200: '#F5A894',
    300: '#F18569',
    400: '#EE6947',
    500: '#EB4D26',
    600: '#D44522',
    700: '#B43B1D',
    800: '#943118',
    900: '#652110',
    DEFAULT: '#EB4D26',
};

// ======================
// PINK/ROSE FAMILY
// ======================

export const brandPink = {
    50: '#FCE5F1',
    100: '#F6BFDC',
    200: '#F094C5',
    300: '#EA69AE',
    400: '#E5479C',
    500: '#E0268A',
    600: '#CA22C5',
    700: '#AF1DA9',
    800: '#94188D',
    900: '#651061',
    DEFAULT: '#E0268A',
};

export const brandRose = {
    50: '#FCE5ED',
    100: '#F6BFD4',
    200: '#F094B7',
    300: '#EA699A',
    400: '#E54784',
    500: '#E0266E',
    600: '#CA2263',
    700: '#AF1D55',
    800: '#941847',
    900: '#651031',
    DEFAULT: '#E0266E',
};

// ======================
// NEUTRAL/GRAY FAMILY
// ======================

export const brandGray = {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    DEFAULT: '#6B7280',
};

export const brandWarmGray = {
    50: '#FAF9F7',
    100: '#F4F2ED',
    200: '#EAE6DE',
    300: '#D9D3C6',
    400: '#B8B0A0',
    500: '#9C917D',
    600: '#7A7160',
    700: '#635B4E',
    800: '#4E473C',
    900: '#342F27',
    DEFAULT: '#9C917D',
};

export const brandCoolGray = {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
    DEFAULT: '#64748B',
};

// ======================
// ADDITIONAL NEW COLORS
// ======================

// YELLOW FAMILY
export const brandYellow = {
    50: '#FFFDE5',
    100: '#FFF9BF',
    200: '#FFF594',
    300: '#FFF169',
    400: '#FFED47',
    500: '#FFE926',
    600: '#E6D222',
    700: '#BFB11D',
    800: '#998F18',
    900: '#665F10',
    DEFAULT: '#FFE926',
};

export const brandGold = {
    50: '#FDF8E5',
    100: '#F9ECBF',
    200: '#F5DF94',
    300: '#F1D269',
    400: '#EEC847',
    500: '#EABF26',
    600: '#D3AC22',
    700: '#B3921D',
    800: '#947718',
    900: '#655110',
    DEFAULT: '#EABF26',
};

// EARTH TONES
export const brandBrown = {
    50: '#F7F3ED',
    100: '#E8DFD0',
    200: '#D7C9AF',
    300: '#C6B38E',
    400: '#B9A275',
    500: '#AC915C',
    600: '#9B8353',
    700: '#816D46',
    800: '#675738',
    900: '#453A26',
    DEFAULT: '#AC915C',
};

export const brandClay = {
    50: '#FAF4F0',
    100: '#F2E3D7',
    200: '#E9D0BB',
    300: '#E0BD9F',
    400: '#D9AE8A',
    500: '#D29F75',
    600: '#BD9169',
    700: '#9E7958',
    800: '#7E6146',
    900: '#54412F',
    DEFAULT: '#D29F75',
};

// JEWEL TONES
export const brandSapphire = {
    50: '#E5EFFA',
    100: '#BFD6F2',
    200: '#94BAEA',
    300: '#699EE2',
    400: '#4788DB',
    500: '#2672D4',
    600: '#2267BF',
    700: '#1D56A1',
    800: '#184683',
    900: '#102F59',
    DEFAULT: '#2672D4',
};

export const brandRuby = {
    50: '#FAE5EA',
    100: '#F2BFCC',
    200: '#EA94AB',
    300: '#E26989',
    400: '#DB4770',
    500: '#D42657',
    600: '#BF224E',
    700: '#A11D42',
    800: '#831836',
    900: '#591025',
    DEFAULT: '#D42657',
};

export const brandJade = {
    50: '#E5FAF0',
    100: '#BFF2D9',
    200: '#94E9C0',
    300: '#69E0A6',
    400: '#47D992',
    500: '#26D27E',
    600: '#22BD72',
    700: '#1DA160',
    800: '#18864E',
    900: '#105B35',
    DEFAULT: '#26D27E',
};

// PASTEL TONES
export const brandLavender = {
    50: '#F7F5FD',
    100: '#EAE6FA',
    200: '#DBD5F7',
    300: '#CCC4F4',
    400: '#C1B7F2',
    500: '#B6AAEF',
    600: '#A499D7',
    700: '#8980B4',
    800: '#6D6690',
    900: '#494561',
    DEFAULT: '#B6AAEF',
};

export const brandPeach = {
    50: '#FEF5F0',
    100: '#FCE5D8',
    200: '#FAD3BD',
    300: '#F8C1A2',
    400: '#F6B38D',
    500: '#F4A578',
    600: '#DC956C',
    700: '#B87C5A',
    800: '#936347',
    900: '#634230',
    DEFAULT: '#F4A578',
};

// ======================
// GRADIENT SUPPORT COLORS
// ======================

export const gradientSunrise = {
    50: '#FFE5EC',
    100: '#FFBFD0',
    200: '#FF94B0',
    300: '#FF6990',
    400: '#FF4777',
    500: '#FF265E',
    600: '#E62255',
    700: '#BF1D47',
    800: '#991839',
    900: '#661026',
    DEFAULT: '#FF265E',
};

export const gradientOcean = {
    50: '#E5F2FF',
    100: '#BFDEFF',
    200: '#94C8FF',
    300: '#69B2FF',
    400: '#47A1FF',
    500: '#2690FF',
    600: '#2282E6',
    700: '#1D6CBF',
    800: '#185699',
    900: '#103A66',
    DEFAULT: '#2690FF',
};

// ======================
// MUTED SEMANTIC COLORS — Professional, desaturated tones
// ======================

export const mutedSuccessColor = {
  50: '#F2F6F2',
  100: '#DDE8DE',
  200: '#C2D4C3',
  300: '#A2BEA4',
  400: '#82A884',
  500: '#5B8C5A',
  600: '#4A7549',
  700: '#3A5E39',
  800: '#2A4729',
  900: '#1A3019',
  DEFAULT: '#5B8C5A',
  light: '#C2D4C3',
  dark: '#3A5E39',
};

export const mutedWarningColor = {
  50: '#FBF6EE',
  100: '#F5E8D3',
  200: '#ECD7B1',
  300: '#E2C48C',
  400: '#DAB26C',
  500: '#D4A04A',
  600: '#BE8E42',
  700: '#A07637',
  800: '#825F2C',
  900: '#5E4420',
  DEFAULT: '#D4A04A',
  light: '#ECD7B1',
  dark: '#A07637',
};

export const mutedErrorColor = {
  50: '#F9F0EF',
  100: '#F0D9D7',
  200: '#E4BCB8',
  300: '#D69D97',
  400: '#CA837C',
  500: '#C46965',
  600: '#AE5E5A',
  700: '#914E4B',
  800: '#743E3B',
  900: '#532C2A',
  DEFAULT: '#C46965',
  light: '#E4BCB8',
  dark: '#914E4B',
};

// SECONDARY COLOR — Muted warm beige/gray accent
export const mutedSecondaryColor = {
  50: '#FAF8F6',
  100: '#F5F0EB',
  200: '#EBE3D9',
  300: '#D9CDBC',
  400: '#C5B5A0',
  500: '#B09B82',
  600: '#9A856C',
  700: '#7F6C56',
  800: '#655440',
  900: '#4A3D2E',
  DEFAULT: '#B09B82',
  light: '#EBE3D9',
  dark: '#7F6C56',
};

// ======================
// EXPORT ALL BRAND COLORS
// ======================

export const brandColors = {
    // Primary
    default: defaultBrandColor,

    // Blues
    sky: brandSky,
    cyan: brandCyan,
    deepOcean: brandDeepOcean,
    sapphire: brandSapphire,

    // Purples/Violets
    purple: brandPurple,
    violet: brandViolet,
    indigo: brandIndigo,
    fuchsia: brandFuchsia,
    lavender: brandLavender,

    // Greens/Teals
    green: brandGreen,
    emerald: brandEmerald,
    teal: brandTeal,
    mint: brandMint,
    lime: brandLime,
    jade: brandJade,

    // Reds/Oranges
    red: brandRed,
    ruby: brandRuby,
    orange: brandOrange,
    amber: brandAmber,
    sunset: brandSunset,
    peach: brandPeach,

    // Pinks/Roses
    pink: brandPink,
    rose: brandRose,

    // Yellows/Golds
    yellow: brandYellow,
    gold: brandGold,

    // Neutrals/Grays
    gray: brandGray,
    warmGray: brandWarmGray,
    coolGray: brandCoolGray,

    // Earth Tones
    brown: brandBrown,
    clay: brandClay,

    // Gradients/Accents
    gradientSunrise,
    gradientOcean,
};